export default __webpack_public_path__ + "static/media/urlapp.3ee228f5.svg";